// import React, { JSX, useEffect, useState } from "react";
// import { Staff } from "../Table/StaffTable";
// import { toast } from "sonner";
// import {
//     useUpdateStaffUserMutation,
// } from "../../redux/services/staffApi";
// import { usePermission } from "../../hooks/usePermission";

// interface PersonalInfoProps {
//     staff: Staff;
//     roleList: any;
//     selectedRole: string;
//     onRoleChange: (roleId: string) => Promise<void>;
//     rolesLoading: boolean;

//     renderInput?: (label: string, value?: string | number) => JSX.Element;
// }

// const PersonalInfo: React.FC<PersonalInfoProps> = ({ staff }) => {

//     // prefill
//     const fullName = staff.name || "";
//     const initialFirstName = fullName.split(" ")[0] || "";
//     const initialLastName =
//         fullName.split(" ").slice(1).join(" ") || "";

//     const [firstName, setFirstName] = useState(initialFirstName);
//     const [lastName, setLastName] = useState(initialLastName);
//     const [phoneNumber, setPhoneNumber] = useState(
//         staff.phone_number || ""
//     );
//     const [gender, setGender] = useState(staff.gender || "");
//     const [isDirty, setIsDirty] = useState(false);

//     const [updateStaffUser, { isLoading }] =
//         useUpdateStaffUserMutation();
//     const {hasPermission} = usePermission();


//     useEffect(() => {
//         const hasChanged =
//             firstName !== initialFirstName ||
//             lastName !== initialLastName ||
//             phoneNumber !== (staff.phone_number || "") ||
//             gender !== (staff.gender || "");

//         setIsDirty(hasChanged);
//     }, [
//         firstName,
//         lastName,
//         phoneNumber,
//         gender,
//         staff,
//         initialFirstName,
//         initialLastName,
//     ]);


//     //   update handler

//     const handleUpdate = async () => {
//         if (!hasPermission("update staff")) {
//             toast.error("You don't have permission to update staff");
//             return;
//         }
//         const formData = new FormData();
//         formData.append(
//             "name",
//             `${firstName} ${lastName}`.trim()
//         );
//         formData.append("phone_number", phoneNumber);
//         formData.append("gender", gender);

//         try {
//             await updateStaffUser({
//                 userId: staff.id,
//                 body: formData,
//             }).unwrap();

//             toast.success("Profile updated successfully");
//             setIsDirty(false);
//         } catch {
//             toast.error("Failed to update profile");
//         }
//     };

//     const formatDate = (dateString?: string) => {
//         if (!dateString) return "N/A";
//         return new Date(dateString).toLocaleString();
//     };

//     return (
//         <div className="space-y-8">
//             {/*basic infor*/}
//             <section>
//                 <h3 className="text-gray-700 font-medium mb-4">
//                     Basic Information
//                 </h3>

//                 <div className="grid grid-cols-2 gap-4">
//                     {/* first name */}
//                     <div>
//                         <label className="text-sm text-gray-600 mb-1 block">
//                             First Name
//                         </label>
//                         <input
//                             value={firstName}
//                             onChange={(e) =>
//                                 setFirstName(e.target.value)
//                             }
//                             className="w-full border rounded-lg px-3 py-2"
//                         />
//                     </div>

//                     {/* last name */}
//                     <div>
//                         <label className="text-sm text-gray-600 mb-1 block">
//                             Last Name
//                         </label>
//                         <input
//                             value={lastName}
//                             onChange={(e) =>
//                                 setLastName(e.target.value)
//                             }
//                             className="w-full border rounded-lg px-3 py-2"
//                         />
//                     </div>

//                     {/* phone */}
//                     <div>
//                         <label className="text-sm text-gray-600 mb-1 block">
//                             Phone Number
//                         </label>
//                         <input
//                             value={phoneNumber}
//                             onChange={(e) =>
//                                 setPhoneNumber(e.target.value)
//                             }
//                             className="w-full border rounded-lg px-3 py-2"
//                         />
//                     </div>

//                     {/* email */}
//                     <div>
//                         <label className="text-sm text-gray-600 mb-1 block">
//                             Email
//                         </label>
//                         <input
//                             value={staff.email || ""}
//                             readOnly
//                             className="w-full border rounded-lg px-3 py-2 bg-gray-100 cursor-not-allowed"
//                         />
//                     </div>

//                     {/* gender */}
//                     <div>
//                         <label className="text-sm text-gray-600 mb-1 block">
//                             Gender
//                         </label>
//                         <select
//                             value={gender}
//                             onChange={(e) =>
//                                 setGender(e.target.value)
//                             }
//                             className="w-full border rounded-lg px-3 py-2"
//                         >
//                             <option value="">Not set</option>
//                             <option value="male">Male</option>
//                             <option value="female">Female</option>
//                         </select>
//                     </div>

//                     {/* role*/}
//                     <div>
//                         <label className="text-sm text-gray-600 mb-1 block">
//                             Role
//                         </label>
//                         <input
//                             value={staff.role || ""}
//                             readOnly
//                             className="w-full border rounded-lg px-3 py-2 bg-gray-100 cursor-not-allowed"
//                         />
//                     </div>
//                 </div>

//                 {/* Update button */}
//                 <div className="mt-6 flex justify-end">
//                     <button
//                         onClick={handleUpdate}
//                         disabled={!isDirty || isLoading || !hasPermission("update staff")}
//                         className={`px-6 py-2 rounded-lg text-white transition
//                             ${isDirty
//                                 ? "bg-[#6226EF]"
//                                 : "bg-gray-400 cursor-not-allowed"
//                             }`}
//                     >
//                         {isLoading ? "Updating..." : "Update"}
//                     </button>
//                 </div>
//             </section>

//             {/* branch*/}
//             <section>
//                 <h3 className="text-gray-700 font-medium mb-4">
//                     Branch
//                 </h3>

//                 <div className="grid grid-cols-2 gap-4">
//                     <input
//                         value={staff.branch || ""}
//                         readOnly
//                         className="border rounded-lg px-3 py-2 bg-gray-100"
//                     />
//                     <input
//                         value={formatDate(staff.dateCreated)}
//                         readOnly
//                         className="border rounded-lg px-3 py-2 bg-gray-100"
//                     />
//                 </div>
//             </section>
//         </div>
//     );
// };

// export default PersonalInfo;


import React, { JSX, useEffect, useState } from "react";
import { Staff } from "../Table/StaffTable";
import { toast } from "sonner";
import { useUpdateStaffUserMutation, useGetRolesQuery } from "../../redux/services/staffApi";
import { usePermission } from "../../hooks/usePermission";
import { selectUser } from "../../redux/slices/authSlice";
import { useSelector } from "react-redux";
import { useGetAllBranchesQuery } from "../../redux/services/fleetManagement";
import { RootState } from "../../redux/services/store";

interface PersonalInfoProps {
    staff: Staff;
    roleList: any;
    selectedRole: string;
    onRoleChange: (roleId: string) => Promise<void>;
    rolesLoading: boolean;
    renderInput?: (label: string, value?: string | number) => JSX.Element;
}

const ReadOnlyBadge = () => (
    <span className="absolute right-3 top-1/2 -translate-y-1/2 text-[10px] bg-gray-100 text-gray-400 border border-gray-200 px-2 py-0.5 rounded-full font-medium">
        Read only
    </span>
);

const Spinner = () => (
    <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24" fill="none">
        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z" />
    </svg>
);

const PersonalInfo: React.FC<PersonalInfoProps> = ({
    staff,
    selectedRole,
    onRoleChange,
    rolesLoading,
}) => {
    const currentUser = useSelector(selectUser);
    const user = useSelector((state: RootState) => state.auth.user);
    const isSuperAdmin = currentUser?.role?.name === "Super Admin";
    const { data: branchesData, isLoading: branchesLoading } = useGetAllBranchesQuery(
        { user_id: user?.id ?? "" },
        { skip: !user?.id }
    );
    const branchData = branchesData?.data?.branchInfo?.data;

    const fullName = staff.name || "";
    const initialFirstName = fullName.split(" ")[0] || "";
    const initialLastName = fullName.split(" ").slice(1).join(" ") || "";

    const [firstName, setFirstName] = useState(initialFirstName);
    const [lastName, setLastName] = useState(initialLastName);
    const [phoneNumber, setPhoneNumber] = useState(staff.phone_number || "");
    const [gender, setGender] = useState(staff.gender || "");
    const [branch, setBranch] = useState(staff.branch_id || "");
    const [localRole, setLocalRole] = useState(selectedRole);
    const [isDirty, setIsDirty] = useState(false);
    const [isRoleDirty, setIsRoleDirty] = useState(false);
    const [isUpdatingRole, setIsUpdatingRole] = useState(false);

    const [updateStaffUser, { isLoading }] = useUpdateStaffUserMutation();
    const { data: rolesData } = useGetRolesQuery();
    const { hasPermission } = usePermission();

    const roleList = Array.isArray(rolesData) ? rolesData : [];

    useEffect(() => {
        const hasChanged =
            firstName !== initialFirstName ||
            lastName !== initialLastName ||
            phoneNumber !== (staff.phone_number || "") ||
            gender !== (staff.gender || "") ||
            branch !== (staff.branch_id || "");
        setIsDirty(hasChanged);
    }, [firstName, lastName, phoneNumber, gender, branch, staff, initialFirstName, initialLastName]);

    const handleUpdate = async () => {
        if (!hasPermission("update staff")) {
            toast.error("You don't have permission to update staff");
            return;
        }
        const formData = new FormData();
        formData.append("name", `${firstName} ${lastName}`.trim());
        formData.append("phone_number", phoneNumber);
        formData.append("gender", gender);
        formData.append("branch_id", branch);

        try {
            await updateStaffUser({ userId: staff.id, body: formData }).unwrap();
            toast.success("Profile updated successfully");
            setIsDirty(false);
        } catch (error: any) {
            const message = error?.data?.message || "Failed to update profile";
            toast.error(message);
        }
    };

    const handleRoleUpdate = async () => {
        setIsUpdatingRole(true);
        try {
            await onRoleChange(localRole);
            setIsRoleDirty(false);
        } catch {
            toast.error("Failed to update role");
        } finally {
            setIsUpdatingRole(false);
        }
    };

    const formatDate = (dateString?: string) => {
        if (!dateString) return "N/A";
        return new Date(dateString).toLocaleDateString("en-GB", {
            day: "2-digit", month: "short", year: "numeric",
        });
    };

    const inputClass =
        "w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm text-gray-800 focus:outline-none focus:ring-2 focus:ring-[#6226EF]/20 focus:border-[#6226EF] transition placeholder:text-gray-300 bg-white";

    const readOnlyClass =
        "w-full border border-gray-100 rounded-xl px-4 py-2.5 pr-24 text-sm text-gray-400 bg-gray-50 cursor-not-allowed";

    return (
        <div className="space-y-6">

            {/* ── Basic Information ─────────────────────────── */}
            <section className="rounded-2xl border border-gray-100 bg-white shadow-sm overflow-hidden">

                {/* Section header */}
                <div className="flex items-center gap-3 px-6 py-4 border-b border-gray-100 bg-gradient-to-r from-[#6226EF]/5 to-transparent">
                    <span className="w-1.5 h-6 bg-[#6226EF] rounded-full" />
                    <div>
                        <h3 className="text-sm font-semibold text-gray-800">Basic Information</h3>
                        <p className="text-xs text-gray-400 mt-0.5">Update personal details below</p>
                    </div>
                </div>

                <div className="p-6 grid grid-cols-1 sm:grid-cols-2 gap-5">

                    {/* First Name */}
                    <div className="flex flex-col gap-1.5">
                        <label className="text-xs font-semibold text-gray-500 uppercase tracking-wider">
                            First Name
                        </label>
                        <input
                            value={firstName}
                            onChange={(e) => setFirstName(e.target.value)}
                            placeholder="Enter first name"
                            className={inputClass}
                        />
                    </div>

                    {/* Last Name */}
                    <div className="flex flex-col gap-1.5">
                        <label className="text-xs font-semibold text-gray-500 uppercase tracking-wider">
                            Last Name
                        </label>
                        <input
                            value={lastName}
                            onChange={(e) => setLastName(e.target.value)}
                            placeholder="Enter last name"
                            className={inputClass}
                        />
                    </div>

                    {/* Phone */}
                    <div className="flex flex-col gap-1.5">
                        <label className="text-xs font-semibold text-gray-500 uppercase tracking-wider">
                            Phone Number
                        </label>
                        <input
                            value={phoneNumber}
                            onChange={(e) => setPhoneNumber(e.target.value)}
                            placeholder="e.g. +2348012345678"
                            className={inputClass}
                        />
                    </div>

                    {/* Email — read only */}
                    <div className="flex flex-col gap-1.5">
                        <label className="text-xs font-semibold text-gray-500 uppercase tracking-wider">
                            Email Address
                        </label>
                        <div className="relative">
                            <input value={staff.email || ""} readOnly className={readOnlyClass} />
                            <ReadOnlyBadge />
                        </div>
                    </div>

                    {/* Gender */}
                    <div className="flex flex-col gap-1.5">
                        <label className="text-xs font-semibold text-gray-500 uppercase tracking-wider">
                            Gender
                        </label>
                        <select
                            value={gender}
                            onChange={(e) => setGender(e.target.value)}
                            className={inputClass}
                        >
                            <option value="">Not set</option>
                            <option value="male">Male</option>
                            <option value="female">Female</option>
                        </select>
                    </div>

                    {/* Branch — now editable */}
                    <div className="flex flex-col gap-1.5">
                        <label className="text-xs font-semibold text-gray-500 uppercase tracking-wider">
                            Branch
                        </label>
                        <select
                            value={branch}
                            onChange={(e) => setBranch(e.target.value)}
                            disabled={branchesLoading}
                            className={inputClass}
                        >
                            <option value="">Not set</option>
                            {branchData?.map((branch: any) => {
                                const locationStr = branch?.branch_detail?.branch_name || '';
                                const label = locationStr.charAt(0).toUpperCase() + locationStr.slice(1);
                                const value = branch?.id;
                                return (
                                    <option key={value} value={value}>
                                        {label}
                                    </option>
                                );
                            })}
                        </select>
                    </div>

                    {/* Date Joined — read only, full width */}
                    <div className="flex flex-col gap-1.5 sm:col-span-2">
                        <label className="text-xs font-semibold text-gray-500 uppercase tracking-wider">
                            Date Joined
                        </label>
                        <div className="relative">
                            <input
                                value={formatDate(staff.dateCreated)}
                                readOnly
                                className={readOnlyClass}
                            />
                            <ReadOnlyBadge />
                        </div>
                    </div>
                </div>

                {/* Footer / Save Button */}
                <div className="px-6 py-4 bg-gray-50 border-t border-gray-100 flex items-center justify-between">
                    <p className="text-xs text-gray-400">
                        {isDirty ? "You have unsaved changes." : "All changes are saved."}
                    </p>
                    <button
                        onClick={handleUpdate}
                        disabled={!isDirty || isLoading || !hasPermission("update staff")}
                        className={`flex items-center gap-2 px-6 py-2.5 rounded-xl text-sm font-semibold text-white transition-all duration-200
              ${isDirty && hasPermission("update staff")
                                ? "bg-[#6226EF] hover:bg-[#511ad4] shadow-lg shadow-[#6226EF]/25 active:scale-95"
                                : "bg-gray-200 text-gray-400 cursor-not-allowed"
                            }`}
                    >
                        {isLoading && <Spinner />}
                        {isLoading ? "Saving..." : "Save Changes"}
                    </button>
                </div>
            </section>

            {/* ── Role Management ───────────────────────────── */}
            <section className="rounded-2xl border border-gray-100 bg-white shadow-sm overflow-hidden">

                {/* Section header */}
                <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100 bg-gradient-to-r from-[#143887]/5 to-transparent">
                    <div className="flex items-center gap-3">
                        <span className="w-1.5 h-6 bg-[#143887] rounded-full" />
                        <div>
                            <h3 className="text-sm font-semibold text-gray-800">Role Management</h3>
                            <p className="text-xs text-gray-400 mt-0.5">
                                {isSuperAdmin ? "Assign or change the staff member's role" : "Role assignment is restricted"}
                            </p>
                        </div>
                    </div>

                    {!isSuperAdmin && (
                        <span className="flex items-center gap-1.5 text-xs bg-amber-50 text-amber-600 border border-amber-200 px-3 py-1.5 rounded-full font-semibold">
                            <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
                            </svg>
                            Super Admin only
                        </span>
                    )}
                </div>

                <div className="p-6">
                    <div className="flex flex-col gap-1.5">
                        <label className="text-xs font-semibold text-gray-500 uppercase tracking-wider">
                            Assigned Role
                        </label>

                        {isSuperAdmin ? (
                            <div className="flex gap-3 items-stretch">
                                <select
                                    value={localRole}
                                    onChange={(e) => {
                                        setLocalRole(e.target.value);
                                        setIsRoleDirty(e.target.value !== selectedRole);
                                    }}
                                    disabled={rolesLoading}
                                    className="flex-1 border border-gray-200 rounded-xl px-4 py-2.5 text-sm text-gray-800 focus:outline-none focus:ring-2 focus:ring-[#143887]/20 focus:border-[#143887] transition bg-white"
                                >
                                    <option value="">Select a role</option>
                                    {roleList.map((role: { id: string; name: string }) => (
                                        <option key={role.id} value={role.id}>
                                            {role.name}
                                        </option>
                                    ))}
                                </select>

                                <button
                                    onClick={handleRoleUpdate}
                                    disabled={!isRoleDirty || isUpdatingRole}
                                    className={`flex items-center gap-2 px-5 py-2.5 rounded-xl text-sm font-semibold text-white transition-all duration-200 whitespace-nowrap
                    ${isRoleDirty
                                            ? "bg-[#143887] hover:bg-[#0f2d6e] shadow-lg shadow-[#143887]/25 active:scale-95"
                                            : "bg-gray-200 text-gray-400 cursor-not-allowed"
                                        }`}
                                >
                                    {isUpdatingRole && <Spinner />}
                                    {isUpdatingRole ? "Updating..." : "Update Role"}
                                </button>
                            </div>
                        ) : (
                            <div className="relative">
                                <input
                                    value={staff.role || "No role assigned"}
                                    readOnly
                                    className={readOnlyClass}
                                />
                                <span className="absolute right-3 top-1/2 -translate-y-1/2 flex items-center gap-1 text-[10px] bg-amber-50 text-amber-500 border border-amber-200 px-2 py-0.5 rounded-full font-semibold">
                                    <svg className="w-2.5 h-2.5" fill="currentColor" viewBox="0 0 20 20">
                                        <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
                                    </svg>
                                    Locked
                                </span>
                            </div>
                        )}

                        {isSuperAdmin && (
                            <p className="text-xs text-gray-400 mt-1 flex items-center gap-1">
                                <svg className="w-3 h-3 text-[#143887]" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                                </svg>
                                As Super Admin, you can reassign roles for any staff member.
                            </p>
                        )}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default PersonalInfo;